import AllPlans from './AllPlans'

export default AllPlans
